import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const MembershipGrowthChart = ({ data }) => {
  return (
    <div className="card">
      <h3 className="text-xl font-heading font-semibold text-foreground mb-6">
        Membership Growth Trend
      </h3>
      <div className="w-full h-80" aria-label="Membership Growth Line Chart">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="month" 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '14px' }}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '14px' }}
            />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'var(--color-card)',
                border: '1px solid var(--color-border)',
                borderRadius: '12px',
                padding: '12px'
              }}
            />
            <Legend 
              wrapperStyle={{ paddingTop: '20px' }}
              iconType="circle"
            />
            <Line 
              type="monotone" 
              dataKey="active" 
              stroke="var(--color-primary)" 
              strokeWidth={3}
              dot={{ fill: 'var(--color-primary)', r: 5 }}
              activeDot={{ r: 7 }}
              name="Active Members"
            />
            <Line 
              type="monotone" 
              dataKey="new" 
              stroke="var(--color-success)" 
              strokeWidth={3}
              dot={{ fill: 'var(--color-success)', r: 5 }}
              activeDot={{ r: 7 }}
              name="New Sign-ups"
            />
            <Line 
              type="monotone" 
              dataKey="churned" 
              stroke="var(--color-error)" 
              strokeWidth={3}
              dot={{ fill: 'var(--color-error)', r: 5 }}
              activeDot={{ r: 7 }}
              name="Churned"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default MembershipGrowthChart;